module.exports = __webpack_public_path__ + "static/img/16.6650775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/16.jpg
// module id = 5VkT
// module chunks = 36